import DadosMedico from './DadosMedico';

export default DadosMedico;
